var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImg1Clicked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_883_7013)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_883_7013",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_883_7013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3499 4.54957C32.1013 4.38247 32.7902 5.07132 32.6231 5.82277C31.2219 12.1246 30.4322 20.8827 25.9605 25.3545C21.4888 29.8264 12.7308 30.6162 6.42911 32.0175C5.67767 32.1846 4.98883 31.4957 5.15591 30.7443C6.55711 24.4425 7.34682 15.6843 11.8185 11.2125C16.2902 6.74068 25.0482 5.95086 31.3499 4.54957Z",
    fill: "#E2BBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.0651 -4.49408C-14.2322 -5.24551 -13.5433 -5.93436 -12.7919 -5.76728C-6.49003 -4.36611 2.26812 -3.57643 6.73997 0.895249C11.2118 5.36693 12.0017 14.1249 13.403 20.4266C13.5701 21.178 12.8812 21.8668 12.1298 21.6998C5.82796 20.2986 -2.9302 19.5089 -7.40204 15.0372C-11.8739 10.5656 -12.6637 1.8076 -14.0651 -4.49408Z",
    fill: "#FFD6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2769 12.0495C29.3439 11.7636 29.9886 10.6603 29.5719 9.63734C29.0336 8.31591 28.3199 7.0696 27.4476 5.93285C26.1685 4.26592 24.5736 2.86725 22.754 1.81669C20.9343 0.766128 18.9256 0.0842573 16.8424 -0.189992C15.4218 -0.377014 13.9856 -0.371977 12.572 -0.177394C11.4778 -0.0267634 10.8447 1.08322 11.1306 2.15014L14.2364 13.7411C14.5223 14.808 15.619 15.4412 16.6859 15.1553L28.2769 12.0495Z",
    fill: "#66B1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48916 12.234C10.0414 13.1906 11.2784 13.53 12.1301 12.8266C14.0412 11.2485 15.4303 9.10509 16.0802 6.6796C16.9039 3.60548 16.4727 0.330041 14.8814 -2.42615C13.2901 -5.18233 10.6691 -7.1935 7.59501 -8.01721C5.16952 -8.66711 2.61871 -8.5358 0.296504 -7.66986C-0.738442 -7.28393 -1.06301 -6.04295 -0.510735 -5.08638L4.48921 3.5738L9.48916 12.234Z",
    fill: "#267CBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.748769 6.37746C-1.13929 5.98694 -1.77609 5.98445 -2.13275 6.40612C-3.44258 7.95467 -4.34222 9.81462 -4.74002 11.8145C-5.20305 14.1423 -4.96541 16.555 -4.05715 18.7477C-3.1489 20.9404 -1.61083 22.8145 0.362565 24.1331C2.33596 25.4517 4.65604 26.1555 7.02942 26.1555C9.4028 26.1555 11.7229 25.4517 13.6963 24.1331C15.6697 22.8145 17.2077 20.9404 18.116 18.7477C19.0242 16.555 19.2619 14.1423 18.7989 11.8145C18.4011 9.81462 17.5014 7.95467 16.1916 6.40612C15.8349 5.98445 15.1981 5.98694 14.8076 6.37747L7.73653 13.4485C7.346 13.839 6.71284 13.839 6.32231 13.4485L-0.748769 6.37746Z",
    fill: "#CFE5FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#00639C",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_883_7013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg1Clicked);
export default __webpack_public_path__ + "static/media/profileImg1Clicked.682dde9a389acaccf238546e99d92700.svg";
export { ForwardRef as ReactComponent };